import { compose } from 'recompose'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import BOTContactUs from './BOTContactUs'
import { isFleetServicePage } from '../helpers'

const mapStateToProps = state => ({
  isFleetServicesPage: isFleetServicePage(state)
})

export default compose(
  withType({ type: 'BOTContactUs' }),
  connect(mapStateToProps)
)(BOTContactUs)
